<template>
  <div class="c-withdraw c-withdraw--pix">
    <div class="margin-bottom">
      <p>
        <small>Saldo disponível:</small> <strong> {{ max | currency }}</strong>
      </p>
    </div>
    <div class="margin-bottom">
      <p>
        <small> Insira o valor que deseja transferir por chave PIX: </small>
      </p>
    </div>
    <BaseInputPrice
      :max="max"
      v-on:price="setValue"
      :limit="walletSummary.current_withdraw_limit"
    />
    <div class="margin-bottom">
      <PixKeyDetails />
    </div>
    <div class="margin-bottom">
      <p class="has-text-secondary">
        <base-icon width="30" height="30" name="painel/attention-line-icon" />
      </p>
      <p>
        Em até <strong>2 horas</strong> o valor solicitado<br />estará
        disponível na sua conta bancária.
      </p>
    </div>
    <div class="c-base-button-bottom-container">
      <base-button-bottom
        @click.native="submit"
        :disabled="
          value <= min ||
          value > max ||
          value > walletSummary.current_withdraw_limit ||
          formLoading ||
          disabled
        "
        :class="{
          'is-support': isValidated,
          'is-loading': formLoading || currentWithdrawLimitLoading,
        }"
        type="button"
        class="is-black is-big"
      >
        <template #icon>
          <base-icon name="close-circle-icon" />
        </template>
        Solicitar Transferência
      </base-button-bottom>
    </div>

    <BaseOperationLoading :value="value" ref="operationLoading" />

    <BaseModalPassword
      :value="value"
      @token-extra="getTokenExtra"
      ref="modalPassword"
    />

    <BaseModalError
      ref="modalErrorApi"
      title="Erro ao enviar sua solicitação"
      icon="error-api"
      :hiddenMessage="true"
      :message="messageModal"
    />

    <ModalPixKeyInvalid
      ref="modalPixKeyInvalid"
      message="Não foi possível efetuar a sua transação"
      @onClose="$router.push({ name: 'carteira-saque' })"
    />
    <ModalWithdrawWithPixError
      ref="modalOwnerSecurity"
      @onClose="$refs.modalPixKeyInvalid.open()"
    />
    <ModalPixKeyOwnerConfirmation
      ref="modalOwnerConfirmation"
      @onConfirm="withdraw('confirm')"
      @onCancel="withdraw('cancel')"
    />
    <ModalWithdrawOrderExpiredError ref="modalWithdrawOrderExpiredError" />
    <ModalWithdrawOrderLimitRateError ref="modalWithdrawOrderLimitRateError" />
    <ModalWithdrawOrderBlockedPerMinutes
      ref="modalWithdrawOrderBlockedPerMinutes"
    />
  </div>
</template>

<script>
import BaseButtonBottom from '@/components/BaseButtonBottom.vue'
import BaseInputPrice from '@/components/Wallet/BaseInputPrice.vue'
import BaseOperationLoading from '@/components/Wallet/BaseOperationLoading.vue'
import PixKeyDetails from '@/components/Wallet/Pix/List/PixKeyDetails.vue'
import ModalPixKeyInvalid from '@/components/Wallet/Pix/Modals/ModalPixKeyInvalid.vue'
import ModalPixKeyOwnerConfirmation from '@/components/Wallet/Pix/Modals/ModalPixKeyOwnerConfirmation.vue'
import ModalWithdrawOrderBlockedPerMinutes from '@/components/Wallet/Pix/Modals/ModalWithdrawOrderBlockedPerMinutes.vue'
import ModalWithdrawOrderExpiredError from '@/components/Wallet/Pix/Modals/ModalWithdrawOrderExpiredError.vue'
import ModalWithdrawOrderLimitRateError from '@/components/Wallet/Pix/Modals/ModalWithdrawOrderLimitRateError.vue'
import ModalWithdrawWithPixError from '@/components/Wallet/Pix/Modals/ModalWithdrawWithPixError.vue'
import { mapGetters } from 'vuex'

import BaseModalError from '@/components/BaseModalError.vue'

import BaseModalPassword from '@/components/BaseModalPassword.vue'

import Wallet from '@/lib/api/Wallet'

export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    BaseInputPrice,
    PixKeyDetails,
    BaseButtonBottom,
    BaseOperationLoading,
    BaseModalError,
    BaseModalPassword,
    ModalWithdrawWithPixError,
    ModalPixKeyInvalid,
    ModalPixKeyOwnerConfirmation,
    ModalWithdrawOrderExpiredError,
    ModalWithdrawOrderLimitRateError,
    ModalWithdrawOrderBlockedPerMinutes,
  },

  computed: {
    ...mapGetters({
      logonToken: 'app/logonToken',
      wedId: 'app/getWedId',
    }),
    lastDraw: {
      get() {
        return this.$store.state.wallet.lastDraw
      },
      set(payload) {
        this.$store.dispatch('setLastDraw', payload)
      },
    },
    walletSummary: {
      get() {
        return this.$store.state.wallet.walletSummary
      },
      set(payload) {
        this.$store.dispatch('setWalletSummary', payload)
      },
    },
    userDataTransfer() {
      return this.$store.state.wallet.userDataTransfer
    },
    max() {
      return this.$store.state.wallet.walletSummary.balance
    },
    isValidated() {
      return (
        this.value > this.min &&
        this.value <= this.max &&
        this.value <= this.walletSummary.current_withdraw_limit
      )
    },

    doubleTokens() {
      return `Bearer ${this.logonToken.token}, Bearer ${this.tokenFromPasswordConfirmation}`
    },

    canWithdraw() {
      return this.logonToken && this.isValidated && this.userDataTransfer
    },
  },

  data() {
    return {
      steps: [],
      formLoading: false,
      passwordLoading: false,
      withdrawLoading: false,
      currentWithdrawLimitLoading: false,
      value: 0,
      min: 0,
      dataModal: null,
      pixKeyFromWithdrawOrder: undefined,
      tokenFromPasswordConfirmation: undefined,
      messageModal:
        '<strong>Infelizmente não foi possível<br />solicitar a transferência para a sua conta</strong>',
    }
  },

  mounted() {
    this.getCurrentWithdrawLimit()
  },

  methods: {
    setValue(value) {
      this.value = value.value
    },

    getTokenExtra(payload) {
      if (!payload.token) {
        this.formLoading = false
      } else if (payload.token == 'error') {
        this.formLoading = false
        this.$refs.modalErrorApi.open()
      } else if (!this.passwordLoading) {
        this.passwordLoading = true
        this.$refs.operationLoading.open()
        this.tokenFromPasswordConfirmation = payload.token
        this.preWithdraw()
      }
    },

    submit() {
      if (this.isValidated && !this.formLoading) {
        this.formLoading = true
        this.$refs.modalPassword.open()
      }
    },

    preWithdraw() {
      if (!this.canWithdraw) return

      const walletApi = new Wallet(this.logonToken)
      const payload = {
        wallet_id: this.wedId,
        bank_account_id: this.userDataTransfer.id,
        pix_key: this.userDataTransfer.pix_key,
        pix_type: this.userDataTransfer.pix_type,
        owner_cpf: this.userDataTransfer.owner_cpf,
        amount: this.value,
      }

      walletApi
        .preWithdraw(payload, this.wedId, this.doubleTokens)
        .then((response) => {
          this.pixKeyFromWithdrawOrder = response.data?.data

          if (this.pixKeyFromWithdrawOrder?.withdraw_order_id) {
            this.$refs.modalOwnerConfirmation.open(this.pixKeyFromWithdrawOrder)
          }
        })
        .catch((error) => {
          const errorData = error?.response?.data
          const errorCode = errorData?.error?.errors[0]?.code
          this.formLoading = false

          switch (errorCode) {
            case 'withdraw_order_limit_rate':
              this.$refs.modalWithdrawOrderLimitRateError.open()
              break
            case 'withdraw_order_blocked_per_minutes':
              this.$refs.modalWithdrawOrderBlockedPerMinutes.open()
              break
            case 'withdraw_order_pix_key_owner_invalid':
            case 'withdraw_order_dict_failed':
              this.$refs.modalOwnerSecurity.open()
              break
            default:
              this.$refs.modalErrorApi.open()
              break
          }
        })
        .finally(() => {
          this.$refs.operationLoading.close()
          this.passwordLoading = false
        })
    },

    withdraw(action) {
      if (!this.canWithdraw && !this.withdrawLoading) return
      this.withdrawLoading = true
      this.$refs.operationLoading.open()

      const walletApi = new Wallet(this.logonToken)
      const payload = {
        to: 'starkbank',
        action,
        category: 'withdraw',
        description: 'Transferência para conta bancária por PIX',
        withdraw_order_id: this.pixKeyFromWithdrawOrder.withdraw_order_id,
      }

      walletApi
        .withdraw(payload, this.wedId, this.doubleTokens)
        .then((response) => {
          const withdrawResponse = response.data?.data

          if (withdrawResponse?.status === 'cancelled') {
            this.$router.push({
              name: 'carteira',
            })
          } else if (withdrawResponse) {
            this.lastDraw = {
              ...withdrawResponse,
              type: 'transaction',
            }
            this.$router.push({
              name: 'carteira-recibo',
              params: { value: this.value },
            })
          }
        })
        .catch((error) => {
          const errorData = error?.response?.data
          const errorCode = errorData?.error?.errors[0]?.code

          switch (errorCode) {
            case 'withdraw_order_expired':
              this.$refs.modalWithdrawOrderExpiredError.open()
              break
            default:
              this.$refs.modalErrorApi.open()
              break
          }
        })
        .finally(() => {
          this.$refs.operationLoading.close()
          this.formLoading = false
          this.withdrawLoading = false
        })
    },

    getCurrentWithdrawLimit() {
      if (!this.walletSummary?.current_withdraw_limit) {
        this.currentWithdrawLimitLoading = true
        const walletApi = new Wallet(this.logonToken)
        const withCurrentWithdrawLimit = true
        walletApi
          .getSummary(withCurrentWithdrawLimit)
          .then((walletSummary) => {
            this.walletSummary = walletSummary
          })
          .finally(() => {
            this.currentWithdrawLimitLoading = false
          })
      }
    },
  },
}
</script>

<style lang="scss">
.c-withdraw {
  max-width: 570px;
  margin: 0 auto;
  text-align: center;

  &--pix {
    margin-top: 45px;
    padding-bottom: 50px;
  }
}

.c-base-input-price {
  margin: 18px auto;
}

.layout {
  padding-bottom: 62px;
}
.c-base-button-bottom-container {
  @include position(fixed, auto, 0, 0, 0);
  width: 100%;
  height: 48px;
}
@media (min-width: $tablet) {
  .c-base-button-bottom-container {
    position: relative;
    text-align: center;
  }
  .layout {
    padding-bottom: 0;
  }
}
</style>
